<template>
  <div class="router-wrapper">
    <div class="os-tabs-w">
      <div class="os-tabs-controls os-tabs-complex">
        <div class="nav-item">
          <h1>{{ $t("general.reports") }}</h1>
        </div>
        <div class="nav-item nav-actions d-none d-sm-block">
          <router-link to="/reports/create" class="button" color="primary" size="xlarge" icon="left">
            <i class="os-icon os-icon-plus-circle"></i>
            <span>{{ $t("reports_index.create_new") }}</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="content-box">
      <div class="row reports-row">
        <div :class="!isUserTester() ? 'col-3' : 'col-6'">
          <div class="pipeline white lined-primary reports-lane">
            <div class="pipeline-header">
              <h5 class="pipeline-name">{{ $t("general.waiting") }}</h5>
            </div>
            <div v-if="getReportsOfLane('CREATED').length < 1" style="color: rgba(0,0,0,0.4);">
              {{ $t("reports_index.no_reports_waiting") }}
            </div>
            <div
              class="pipeline-item"
              v-for="report in getReportsOfLane('CREATED')"
              v-bind:key="report.id"
              style="cursor: default"
            >
              <div class="pi-body pi-body-custom">
                <div class="pi-info-custom">
                  <div class="h6 pi-name pi-name-custom">{{ report.name }}</div>
                  <div class="pi-sub"># {{ report.report_number }}</div>
                </div>
                <div class="circle-container">
                  <div class="circle" :validation="report.dataValidation"></div>
                  <div class="circle progress-circle" :progress="report.dataProgress"></div>
                </div>
              </div>
              <div class="justify-content-center" style="border-top: 1px solid #d1d4e8;">
                <report-button-bar :report="report" position="start" />
              </div>
            </div>
          </div>
        </div>
        <div :class="!isUserTester() ? 'col-3' : 'col-6'">
          <div class="pipeline white lined-primary reports-lane">
            <div class="pipeline-header">
              <h5 class="pipeline-name">{{ $t("general.in_progress") }}</h5>
            </div>
            <div v-if="getReportsOfLane('IN_PROGRESS').length < 1" style="color: rgba(0,0,0,0.4);">
              {{ $t("reports_index.no_reports_in_progress") }}
            </div>
            <div class="pipeline-item" v-for="report in getReportsOfLane('IN_PROGRESS')" style="cursor: default">
              <div class="pi-body pi-body-custom">
                <div class="pi-info-custom">
                  <div class="h6 pi-name pi-name-custom">{{ report.name }}</div>
                  <div class="pi-sub"># {{ report.report_number }}</div>
                </div>
                <div class="circle-container">
                  <div class="circle" :validation="report.dataValidation"></div>
                  <div class="circle progress-circle" :progress="report.dataProgress"></div>
                </div>
              </div>
              <div class="justify-content-center" style="border-top: 1px solid #d1d4e8;">
                <report-button-bar :report="report" position="start" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-3" v-if="!isUserTester()">
          <div class="pipeline white lined-primary reports-lane">
            <div class="pipeline-header">
              <h5 class="pipeline-name">
                {{ $t("reports_index.measurements_done") }}
              </h5>
            </div>
            <div v-if="getReportsOfLane('DONE_GATHERING').length < 1" style="color: rgba(0,0,0,0.4);">
              {{ $t("reports_index.no_reports_finished_measurement") }}
            </div>
            <div class="pipeline-item" v-for="report in getReportsOfLane('DONE_GATHERING')" style="cursor: default">
              <div class="pi-body pi-body-custom">
                <div class="pi-info-custom ">
                  <div class="h6 pi-name pi-name-custom">{{ report.name }}</div>
                  <div class="pi-sub"># {{ report.report_number }}</div>
                </div>
                <div class="circle-container">
                  <div class="circle" :validation="report.dataValidation"></div>
                  <div class="circle progress-circle" :progress="report.dataProgress"></div>
                </div>
              </div>
              <div class="justify-content-center" style="border-top: 1px solid #d1d4e8;">
                <report-button-bar :report="report" position="start" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-3" v-if="!isUserTester()">
          <div class="pipeline white lined-primary reports-lane">
            <div class="pipeline-header">
              <h5 class="pipeline-name">{{ $t("general.completed") }}</h5>
            </div>
            <div v-if="getReportsOfLane('COMPLETED').length < 1" style="color: rgba(0,0,0,0.4);">
              {{ $t("reports_index.no_reports_completed") }}
            </div>
            <div class="pipeline-item" v-for="report in getReportsOfLane('COMPLETED')" style="cursor: default">
              <div class="pi-body pi-body-custom">
                <div class="pi-info-custom">
                  <div class="h6 pi-name pi-name-custom">{{ report.name }}</div>
                  <div class="pi-sub"># {{ report.report_number }}</div>
                </div>
                <div class="circle-container">
                  <div class="circle" :validation="report.dataValidation"></div>
                  <div class="circle progress-circle" :progress="report.dataProgress"></div>
                </div>
              </div>
              <div class="justify-content-center" style="border-top: 1px solid #d1d4e8;">
                <report-button-bar :report="report" position="start" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { UserService } from "@/services/UserService";
import { Fragment } from "vue-fragment";
import { NewReportStore } from "@/store/NewReportStore";
import ReportButtonBar from "@/components/reports/partials/report-button-bar";

export default {
  name: "ReportsIndex",
  components: {
    ReportButtonBar,
    ClipLoader,
    Fragment
  },
  model: {
    UserService
  },
  data() {
    return {
      deletedReports: [],
      supervisorName: "",
      USER_ROLE: ""
    };
  },
  methods: {
    getReportsOfLane(lane) {
      return NewReportStore.reports.filter(r => r.step === lane);
    },
    isUserTester() {
      return UserService.isUserTester();
    },
    isUserViewer() {
      return UserService.isUserViewer();
    }
  },
  mounted() {
    this.USER_ROLE = JSON.parse(sessionStorage.getItem("cedoon_user")).role;
    NewReportStore.fetchReportOverview();
  }
};
</script>

<style scoped lang="scss">
@import "./src/assets/theme/_variables.scss";
@import "./src/assets/controls/mix-ins/_hover.scss";
.reports-row {
  height: 100%;
}
.reports-lane {
  height: 100%;
}
.pi-body-custom {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.pi-info-custom {
  flex: 5;
  overflow: auto;
}
.pi-name-custom {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.circle-container {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.progress-circle {
  margin-left: $spacing-unit;
}
.delete-icon {
  cursor: pointer;
  color: $error-color;
  padding-left: 10px;
}
</style>
